import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// for professional curriculum learning path
// const root = ReactDOM.createRoot(
//   document.getElementById('react-root') as HTMLElement
// );

// for foundations learning path
const root = ReactDOM.createRoot(
  document.getElementById('foundation-react-root') as HTMLElement
);
root.render(<App />);
